import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./home/Home";
import Soon from "./home/Soon";
import BlogLayout from "./blog/BlogLayout";
import PostPage from "./blog/PostPage.";
import Blog from "./blog/Blog";
import Error from "./Error";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:lang/" element={<Home />} />
        <Route path="/:lang/soon" element={<Soon />} />
        <Route path="/" element={<Navigate to="/en" />} />
        <Route path="/:id/blog" element={<BlogLayout />}>
          <Route path=":id" element={<PostPage />} />
          <Route index element={<Blog />} />
        </Route>
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
